import { BoxGeometry, Mesh, MeshBasicMaterial, PlaneGeometry, Scene } from 'three';

import Character from './Character.js';
import { lisa } from './Lisa.js';
import BackgroundMaterial from './Materials/Background/Background.js';
import { computeEnvmap } from './utils/misc.js';

class MainScene extends Scene {
	constructor() {
		super();
		lisa.state.register(this);
	}

	onAppLoaded() {
		this.environment = computeEnvmap(lisa.renderer, lisa.assets.envmap);
		this.lisa = new Character();
		this.add(this.lisa);

		const backgroundPlane = new Mesh(new PlaneGeometry(30, 30), new BackgroundMaterial());
		backgroundPlane.position.z = -5;
		this.add(backgroundPlane);
	}
}

export { MainScene };
